<div class="lnr-sidemenu-container">
  <div class="lnr-sidemenu-topbar">
    <h3>{{ sideMenuItems.menu | transloco }}</h3>
    <mat-icon class="lnr-sidemenu-close" (click)="onClose()">cancel</mat-icon>
  </div>
  <app-sidemenu-item id="lnr-sidemenuitem-add-points" (click)="onRoute(RoutesKeys.ADD_POINTS)"
                     icon="{{ sideMenuItems.addPoints[1] }}">
    {{ sideMenuItems.addPoints[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-home" (click)="onRoute(RoutesKeys.HOME)"
                     icon="{{ sideMenuItems.home[1] }}">
    {{ sideMenuItems.home[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-rewards" (click)="onRoute(RoutesKeys.REWARDS)"
                     icon="{{ sideMenuItems.rewards[1] }}">
    {{ sideMenuItems.rewards[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-coupons" (click)="onRoute(RoutesKeys.COUPONS)"
                      icon="{{ sideMenuItems.coupons[1] }}">
    {{ sideMenuItems.coupons[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-pointbalance" (click)="onRoute(RoutesKeys.POINT_BALANCE)"
                     icon="{{ sideMenuItems.pointBalance[1] }}">
    {{ sideMenuItems.pointBalance[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-businesssettings"
                     (click)="onRoute(RoutesKeys.BUSINESS_SETTINGS)"
                     icon="{{ sideMenuItems.businessSettings[1] }}">
    {{ sideMenuItems.businessSettings[0] | transloco }}
  </app-sidemenu-item>
  <app-sidemenu-item id="lnr-sidemenuitem-accountsettings"
                    (click)="onRoute(RoutesKeys.ACCOUNT_SETTINGS)"
                    icon="{{ sideMenuItems.accountSettings[1] }}">
    {{ sideMenuItems.accountSettings[0] | transloco }}
</app-sidemenu-item>
</div>
